var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "13px",
    viewBox: "0 0 18 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0B3EC31D-94B7-4E63-9E93-08D14FB5B446") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4-1---Data-Map---Inspecting-a-Component",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4-1-2---Data-Map---Inspecting-a-Component",
    transform: "translate(-747.000000, -386.000000)",
    fill: "#292929"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M755.168231,386.737921 L755.007785,386.746459 C752.822286,386.894491 750.941343,388.322485 750.200601,390.363014 L750.160687,390.47775 L750.11269,390.48907 C748.251299,390.953117 746.944432,392.674883 747.038146,394.628946 C747.0375,396.914925 748.731725,398.8185 750.852,398.8185 L760.338,398.8185 C762.919789,398.8185 764.9625,396.514439 764.9625,393.69 C764.9625,390.861701 762.916784,388.5375 760.338,388.5375 L760.135764,388.546307 C759.867348,388.564218 759.604022,388.606744 759.347719,388.673188 L759.20625,388.713188 L759.151442,388.644216 C758.181762,387.469129 756.741066,386.766007 755.200371,386.737596 L755.168231,386.737921 Z M755.060635,387.870524 L755.192812,387.862687 L755.179629,387.862404 C756.529747,387.887302 757.782126,388.571673 758.532282,389.694484 C758.681602,389.917981 758.968176,390.004608 759.216298,389.901251 C759.575836,389.751483 759.960269,389.670459 760.349669,389.662379 C762.261243,389.6625 763.8375,391.453335 763.8375,393.69 C763.8375,395.921264 762.266289,397.6935 760.338,397.6935 L750.852,397.6935 C749.42177,397.6935 748.22531,396.390401 748.164893,394.733524 L748.1625,394.602 C748.089224,393.060622 749.179603,391.739083 750.680262,391.522744 C750.902995,391.490635 751.085155,391.328866 751.14336,391.111488 C751.627687,389.302647 753.204035,388.006208 755.060635,387.870524 Z",
    id: "internet-cloud"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.c508c47acd68c346b4d2c22714d3c108.svg";
export { ForwardRef as ReactComponent };